import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import axios from '../../../axios-local-api';
import Modal from '../../../components/UI/Modal/Modal';
import Box from '../../../hoc/Box/Box';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import PauseScheduleForm from '../PauseScheduleForm/PauseScheduleForm';
import classes from './PauseScheduleLink.css';
import { FaExclamationTriangle } from 'react-icons/fa';

class PauseScheduleLink extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCreatePauseScheduleForm: false,
      template: this.props.customTemp,
      customTemp: this.props.customTemp,
      canEdit:
        this.props.customTemp &&
        this.props.customTemp.customSchedules &&
        this.props.customTemp.customSchedules.length
          ? true
          : false,
      groupScheduleVisiblity: false,
      steeringDevices: false
    };
    this.closeScheduleSteeringMessageModal = this.closeScheduleSteeringMessageModal.bind(this);
  }
  componentDidMount() {}
  modalCancelHandlerForCreatePauseScheduleForm = () => {
    this.props.modalCancel();
    this.setState({ showCreatePauseScheduleForm: false });
  };

  closeScheduleSteeringMessageModal(){
    this.setState({
      steeringDevices : false
    })
  }


  closeModal = () => {
    this.setState({ showCreatePauseScheduleForm: false });
  };

  confirmModalCancelHandler = () => {
    this.props.onCancel();
  };

  isCustomTemplateEnabled() {
    let customTemplate = this.props.customTemp;
    //console.log("customTemplate", customTemplate);
    // console.log("customTemplate.enable", customTemplate.enable);

    return customTemplate.enable;
  }

  getSelectedDays(daysOfWeek) {
    let days = {
      1: 'Mo',
      2: 'Tu',
      3: 'We',
      4: 'Th',
      5: 'Fr',
      6: 'Sa',
      7: 'Su',
    };
    daysOfWeek.sort();
    return daysOfWeek.map((d) => days[d]).join(', ');
  }

  convertTo12Hour(hour) {
    // Manually split the time if `hour` is null
    // null represents "00:00"
    let hrs = hour === null ? ['00', '00'] : hour.split(':');
    let hr = parseInt(hrs[0], 10);
    let m = hrs[1];

    let remainder = hr % 12;
    let h = remainder === 0 ? 12 : remainder;

    let ampm = hr < 12 ? 'AM' : 'PM';
    let value = h + ':' + m + ' ' + ampm;
    return value;
  }

  render() {
    //  console.log("PauseScheduleLink this.props", this.props);
    // console.log(this.state.canEdit);
    // console.log('CUST TEMP', this.props.customTemp)
    if (this.props.freeze === undefined) {
      return <Box> &nbsp; </Box>;
    }
    let buttonName = this.state.canEdit
      ? 'Edit Device Schedule'
      : 'Create Device Pause Schedule';
    let displayGroupScheduleLink = false;
    if (
      this.state.canEdit &&
      this.props.deviceGroupName !== 'Ungrouped' &&
      this.props.deviceGroupName !== 'UnGrouped'
    ) {
      buttonName = 'Edit Group Schedule';
      displayGroupScheduleLink = true;
    }

    let customTemplate = this.props.customTemp;
    let selectedDays = '';
    let startTime = '';
    let endTime = '';
    let selectedTime = '';
    let schedulePauseHtml;
    if (this.state.canEdit) {
      let schedule =
        customTemplate && customTemplate.customSchedules
          ? customTemplate.customSchedules
          : undefined;
      // if(schedule[0]
      // && (schedule[0].endTime === null || schedule[0].endTime === "null")
      // && (customTemplate&&customTemplate.customSchedules && customTemplate.customSchedules[1] && customTemplate.customSchedules[1].endTime)
      // && (customTemplate.customSchedules[1].startTime === "00:00")
      // ){
      //   schedule[0].endTime = customTemplate&&customTemplate.customSchedules?customTemplate.customSchedules[1].endTime:'midnight'
      // }
      selectedDays =
        schedule && schedule[0] && schedule[0].daysOfWeek
          ? this.getSelectedDays(schedule[0].daysOfWeek)
          : '';
      startTime =
      schedule && schedule[0] && schedule[0].startTime
          ? this.convertTo12Hour(schedule[0].startTime)
          : '';
      // endTime =  schedule[0] && schedule[0].endTime ? this.convertTo12Hour(schedule[0].endTime):"midnight";
      // endTime =  schedule[1] && schedule[1].endTime ? this.convertTo12Hour(schedule[1].endTime):this.convertTo12Hour(schedule[0].endTime);
      if (schedule && schedule[1] && schedule[1].endTime) {
        endTime = this.convertTo12Hour(schedule[1].endTime);
      } else {
        if (schedule && schedule[0] && schedule[0].endTime === null) {
          endTime = this.convertTo12Hour('00:00');
        } else {
          endTime =
          schedule && schedule[0] && schedule[0].endTime
              ? this.convertTo12Hour(schedule[0].endTime)
              : '';
        }
      }
      selectedTime = startTime + '-' + endTime;
      let changeGroupObject = {
        deviceMac: this.props.devMac,
        showMoveDeviceModal: false,
        groupName: this.props.deviceGroupName,
      };
      let groupScheduleLinkHtml;
      if (this.state.groupScheduleVisiblity && displayGroupScheduleLink) {
        groupScheduleLinkHtml = (
          <span className={classes.GroupScheduleToolTip}>
            Need to edit schedule? Click
            <Link
              to={{
                pathname: '/advancedconfigurations',
                query: changeGroupObject,
              }}
              onClick={this.props.setEquipmentSelection}
            >
              Here
            </Link>
          </span>
        );
      } else {
        groupScheduleLinkHtml = <span></span>;
      }
   //   console.log('Pause Schedule Link :::', this.props);
      schedulePauseHtml = (
        <Box>
          <div id="DeviceSchedulePauseDetails">
            <span className={classes.EditSchedulePauseDetails}>
              {selectedDays}
            </span>
            <span className={classes.EditSchedulePauseDetails}>
              {selectedTime}
            </span>
            {groupScheduleLinkHtml}
            <div
              onClick={(e) => {
                if (this.state.groupScheduleVisiblity) {
                  this.setState({ groupScheduleVisiblity: false });
                } else {
                  this.setState({ groupScheduleVisiblity: true });
                }
              }}
              className={classes.ScheduleLink}
              style={{ float: 'left' }}
            >
              { <button
                className={classes.RegularButton}
                id="EditSchedule"
                style={
                  this.props.deviceGroupName === 'Ungrouped' ||
                  this.props.deviceGroupName === 'UnGrouped'
                    ? {}
                    : {
                        background: 'none',
                        pointerEvents: 'none',
                        opacity: '0.5',
                        color: 'dimgrey',
                      }
                }
                onClick={(e) => {
                  this.setState({ showCreatePauseScheduleForm: true });
                }}
                // title={this.props.isDeviceSteering ? 'Device is steering and pause cannot be edited' : ''}
                // disabled={this.props.isDeviceSteering ?  true : false}
              >
               {buttonName}
              </button> }
              {this.state.showCreatePauseScheduleForm && (
                <Modal
                  show={this.state.showCreatePauseScheduleForm}
                  modalClosed={
                    this.modalCancelHandlerForCreatePauseScheduleForm
                  }
                >
                  <PauseScheduleForm
                    closeModal={this.closeModal}
                    onCancel={this.modalCancelHandlerForCreatePauseScheduleForm}
                    updateScheduleDetails={this.props.updateScheduleDetails}
                    devMac={this.props.devMac}
                    template={Object.assign({}, this.props.customTemp)}
                    customEnabled={
                      this.props.customTemp
                        ? this.props.customTemp.enable
                        : false
                    }
                    handleDeviceSteering={this.props.handleDeviceSteering}
                    isDeviceSuspend={this.props.isDeviceSuspend}
                    selectedEquipment={this.props.selectedEquipment}
                  />
                </Modal>
              )}
            </div>
          </div>
        </Box>
      );
    } else {
      schedulePauseHtml = (
        <Box>
          <div>
            <div id="CreateSchedule" style={{ float: 'left' }}>
              <button
                className={classes.RegularButton}
                style={
                  this.props.deviceGroupName === 'Ungrouped' ||
                  this.props.deviceGroupName === 'UnGrouped'
                    ? {}
                    : {
                        background: 'none',
                        pointerEvents: 'none',
                        opacity: '0.5',
                        color: 'dimgrey',
                      }
                }
                onClick={(e) => {
                  // if (this.props.isDeviceSteering) {
                  //   this.setState({ steeringDevices: true });
                  // } 
                    this.setState({ showCreatePauseScheduleForm: true });
                  }
                 
                }
              >
                {buttonName}
              </button>
              {this.state.showCreatePauseScheduleForm && (
                <Modal
                  show={this.state.showCreatePauseScheduleForm}
                  modalClosed={
                    this.modalCancelHandlerForCreatePauseScheduleForm
                  }
                >
                  <PauseScheduleForm
                    closeModal={this.closeModal}
                    onCancel={this.modalCancelHandlerForCreatePauseScheduleForm}
                    devMac={this.props.devMac}
                    updateScheduleDetails={this.props.updateScheduleDetails}
                    template={Object.assign({}, this.props.customTemp)}
                    customEnabled={
                      this.props.customTemp
                        ? this.props.customTemp.enable
                        : false
                    }
                    handleDeviceSteering={this.props.handleDeviceSteering}
                    isDeviceSuspend={this.props.isDeviceSuspend}
                    selectedEquipment={this.props.selectedEquipment}
                  />
                </Modal>
              )}
               {/* {this.state.steeringDevices && (
          <Modal
          deviceGroupConfirmation="true"
          show={this.state.steeringDevices}
         modalClosed={this.closeScheduleSteeringMessageModal}
        >
         <div>
           <div style={{ display:'flex', flexDirection:'row', padding: '25px 5px 5px 5px' }}>
              <FaExclamationTriangle
              id= 'DSAlertIcon'
              color={'red'}
              fontSize={'80px'}
              style={{ marginRight: '5px', marginTop: '8px' }} />
              <p style={{ textAlign: 'center', fontWeight: 'normal' }}>
              The selected smartphone/tablet has been steered and must not be paused or scheduled to begin a scheduled pause in the next {this.props.leftOutTime} minutes.
              </p>
            </div>
            <button className={classes.DeviceSteeringRegularButton} onClick={this.closeScheduleSteeringMessageModal}>
              OK
            </button>
          </div>                              
        </Modal>
        )} */}
            </div>
          </div>
        </Box>
      );
    }

    return schedulePauseHtml;
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(PauseScheduleLink, axios));
